<template lang="pug">
  .order-detail
    el-card(v-watermark="'in'" style="overflow:hidden")
      h4 车辆信息
      el-row
        el-col(:span="8") 车牌号：{{ info.plateNumber }}
        el-col(:span="8") 车辆颜色：{{ info.vehicleColor }}
      el-row
        el-col(:span="8") 车辆名称和型号：{{ info.vehicleType }}
        el-col(:span="8") 司机姓名：{{ info.driverName }}
      el-row
        el-col(:span="8") 司机身份证号：{{ info.driverIdCard }}
        el-col(:span="8") 司机手机号：{{ info.driverPhone }}
      el-row
        el-col(:span="8") 司机户籍所在地：{{ info.driverBirthPlace }}
        el-col(:span="8") 最近一次接单时间：{{ info.latestJourneyTime }}
      hr
      h4 订单乘客
      el-tabs
        el-tab-pane(v-for="tab in tabs" :label="tab.label" :key="tab.deltaDate")
          grid(
            :remoteMethod="getTableData"
            :pageSize="10"
            styles="height:1420px;margin-bottom:12px;width:100%;"
            v-show="tab.show"
            ref="grid"
            layout="prev, pager, next, jumper"
          )
            el-table-column(label="乘客" align="center" min-width="150%")
              template(slot-scope="scope")
                p {{ scope.row.passengerInfo.userName }}
                p {{ scope.row.passengerInfo.idCard }}
                p {{ scope.row.passengerInfo.mobile }}
            el-table-column(label="司机" align="center" min-width="150%")
              template(slot-scope="scope")
                p {{ scope.row.driverInfo.userName }}
                p {{ scope.row.driverInfo.idCard }}
                p {{ scope.row.driverInfo.mobile }}
            el-table-column(label="上车时间" align="center")
              template(slot-scope="scope")
                span {{ scope.row.aboardTime | dateFormat }}
            el-table-column(label="上车地址" align="center" prop="origin.longAddr")
            el-table-column(label="到达时间" align="center")
              template(slot-scope="scope")
                span {{ scope.row.arriveTime | dateFormat }}
            el-table-column(label="到达地址" align="center" prop="destination.longAddr")
            el-table-column(label="是否拼车" align="center" prop="poolStatus")
            el-table-column(label="操作")
              template(slot-scope="scope")
                el-button(type="text" @click="() => clickDetail(scope.row)") 详情
</template>

<script>
import moment from 'moment';
import AMap from '@/components/AMap';
import { getDriverInfo, findHitchJourneyList } from '@/api/hitch';
import deepCopy from '@/utils/deepCopy';
import grid from '@/components/grid';

const defaultModel = {
  sameJourneyList: [],
  origin: {
    location: {},
  },
  destination: {
    location: {},
  },
  passengerInfo: {},
  driverInfo: {},
  driverReportPointList: [],
};
export default {
  components: {
    grid,
    AMap,
  },
  filters: {
    dateFormat(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  data() {
    return {
      info: deepCopy(defaultModel),
      tabs: [{
        label: '最近7天',
        deltaDate: 7,
        show: false,
      }, {
        label: '最近30天',
        deltaDate: 30,
        show: false,
      }]
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    clickDetail(item) {
      this.$router.push({
        name: 'hitchDetail',
        query: {
          guid: item.paxJourneyGuid,
        },
      });// 跳转详情页面
    },
    async loadData() {
      const { newId } = this.$route.query;
      const { data } = await getDriverInfo(newId);
      this.info = Object.assign(deepCopy(defaultModel), data);
      // eslint-disable-next-line max-len
      await Promise.all((this.$refs.grid || []).map((i, index) => i.loadData(this.getParams({ deltaDate: this.tabs[index].deltaDate }))));
      this.tabs = this.tabs.map((i) => {
        i.show = true;
        return i;
      });
    },
    getParams({ deltaDate = 7 }) {
      const now = (new Date().getTime());
      const oneDay = 24 * 60 * 60 * 1000;
      return {
        driverIdCard: this.$route.query.driverIdCard,
        aboardStartTime: now - (deltaDate * oneDay),
        aboardEndTime: now,
      };
    },
    async getTableData(params) {
      const {
        page,
        rows,
        ...restParms
      } = params;
      restParms.startPage = page - 1;
      restParms.pageSize = rows;
      const { data } = await findHitchJourneyList(restParms);
      return { data: data.list, total: data.total };
    },
  },
};
</script>

<style lang="less" scoped>
.order-detail {
  max-height: 100%;
  width: 100%;
  padding: 12px 20px;
  font-size: 14px;
  overflow: auto;

  p, .el-row {
    margin: 14px 0;
  }
  h4 {
    margin-top: 8px;
  }

  hr {
    border: none;
    border-bottom: solid 1px #eee;
    margin: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/info/hitch/vehicle.vue?2f83c99b